<template>
  <nav class="kpt-configurator-navigation">
    <div class="configurator-brand">
      <h5>
        <a @click="setActivePage(0)"><img src="@/assets/configurator/configurator-logo.png" alt="Kymeta Access" /></a>
      </h5>
    </div>
    <div class="configurator-profile">
      <div class="is-flex" v-if="userIsKymeta && infoBoxVisible">
        <div v-if="wholesalePricesVisible" class="mr-2">
          <b-tag type="is-success" v-if="wholesale">Wholesale ON</b-tag>
          <b-tag type="is-light" v-else>Wholesale OFF</b-tag>
        </div>
        <div v-if="msrpPricesVisible" class="mr-2">
          <b-tag type="is-success" v-if="showPrices">Prices ON</b-tag>
          <b-tag type="is-light" v-else>Prices OFF</b-tag>
        </div>
        <!-- <div class="mr-2">
          <b-tag>Discount {{discountTiers.find(dc => dc.id == wholesalePricesShown).name}}</b-tag>
        </div> -->
      </div>
      <b-dropdown
       aria-role="list" 
       position="is-bottom-left">
          <template #trigger>
            <span class="configurator-profile-menu is-clickable">
              <b-icon icon="bars" size="is-medium"></b-icon>
            </span>
          </template>
          <template v-if="wholesalePricesVisible">
            <b-dropdown-item class="configurator-profile-item pa-3" aria-role="listitem" custom>
              <b-switch :value="wholesale" @input="(value) => setPricingVisibility('setWholesaleFlag', value)">Show Wholesale Prices</b-switch>
            </b-dropdown-item>
          </template>
          <template v-if="msrpPricesVisible">
            <b-dropdown-item class="configurator-profile-item pa-3" aria-role="listitem" custom>
              <b-switch :value="showPrices" @input="(value) => setPricingVisibility('setShowPricesFlag', value)">Show Prices</b-switch>
            </b-dropdown-item>
          </template>
          <template>
            <b-dropdown-item class="configurator-profile-item pa-3 pb-0" aria-role="listitem" custom>
              <b-switch :value="infoBoxVisible" @input="(value) => setInfoBoxVisibility(value)">Show Info Box</b-switch>
            </b-dropdown-item>
            <hr class="dropdown-divider">
          </template>
          <!-- <template v-if="userIsKymeta">
            <div class="px-4 py-1">
              <b-field label="Discount Tier">
                <b-select size="is-small" expanded v-model="wholesalePricesShown" @input="(value) => setDiscountTier(value)">
                  <option :value="d.id" v-for="d in discountTiers" :key="d.id">
                    {{ d.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <hr class="dropdown-divider">
          </template> -->
          <b-dropdown-item class="configurator-profile-item" aria-role="listitem" @click="goToContactUs">Contact Us</b-dropdown-item>
          <b-dropdown-item class="configurator-profile-item" aria-role="listitem" @click="returnToPortal">Back to Access Portal</b-dropdown-item>
      </b-dropdown>
      
      <span class="configurator-profile-cart is-clickable ml-2" @click="setActivePage(2)">
        <span class="badge is-badge-small is-badge-danger cart-badge" :data-badge="$store.state.configurator.cart.length" v-if="$store.state.configurator.cart.length > 0">
          <b-icon icon="shopping-cart" size="is-medium"></b-icon>
        </span>
        <b-icon icon="shopping-cart" size="is-medium" v-else></b-icon>
      </span>
    </div>
  </nav>
</template>
<script>
import { computed, ref, getCurrentInstance } from 'vue';

export default {
  setup() {
    const app = getCurrentInstance();
    const root = app.proxy.$root;
    const am = computed(() => root.$store.getters['configurator/analyticsMetadata']);
    const activePage = computed(() => root.$store.state.configurator.activePage);
    const wholesale = computed(() => root.$store.state.configurator.wholesale);
    const showPrices = computed(() => root.$store.state.configurator.showPrices);
    const configPermissions = computed(() => root.$store.getters['configurator/configuratorPermissions']);
    const userIsKymeta = computed(() => root.$store.getters['configurator/userIsKymeta']);
    const wholesalePricesShown = ref('discountTier1Price');
    const infoBoxVisible = computed(() => root.$store.state.configurator.infoBoxVisible);

    const setActivePage = (pageNumber) => {
      if (activePage.value == 1) {
        root.$buefy.dialog.confirm({
          message: 'By leaving this page, you will reset your current configuration. Do you want to continue?',
          onConfirm: () => {
            root.$kya.event('configurator', 'abandonConfigureTerminal', 'Exited terminal configurator without adding to cart.', { ...am.value });
            root.$store.commit('configurator/setCartItemUnderEdit', null);
            root.$store.commit('configurator/setActivePage', pageNumber);
          },
          type: 'is-warning',
          hasIcon: true,
          cancelText: 'No',
          confirmText: 'Yes'
        });
      } else {
        root.$store.commit('configurator/setActivePage', pageNumber);
      }
    }

    const goToContactUs = () => {
      root.$kya.event('configurator', 'openContactUsFromHamburgerMenu', 'Clicked on Contact Us from the hamburger menu.', am.value);
      setActivePage(5);
    }

    const returnToPortal = () => {
      root.$router.push('Home');
      root.$store.commit('configurator/setCartItemUnderEdit', null);
      root.$store.commit('configurator/emptyCart');
      root.$store.commit('configurator/setActivePage', 0);
    }

    const setPricingVisibility = (method, value) => {
      root.$store.commit(`configurator/${method}`, value);
    }

    const setDiscountTier = (value) => {
      root.$store.commit('configurator/setDiscountTier', value);
    }

    const setInfoBoxVisibility = (value) => {
      root.$store.commit('configurator/setInfoBoxVisibility', value);
    }

    const discountTiers = [
      { id: 'discountTier1Price', name: 'Tier 1' },
      { id: 'discountTier2Price', name: 'Tier 2' },
      { id: 'discountTier3Price', name: 'Tier 3' },
      { id: 'discountTier4Price', name: 'Tier 4' },
      { id: 'discountTier5Price', name: 'Tier 5' },
    ]

    return {
      activePage,
      setActivePage,
      wholesale,
      showPrices,
      returnToPortal,
      msrpPricesVisible: configPermissions.value.msrpPricesVisible,
      wholesalePricesVisible: configPermissions.value.wholesalePricesVisible,
      userIsKymeta,
      setPricingVisibility,
      discountTiers,
      setDiscountTier,
      wholesalePricesShown,
      infoBoxVisible,
      setInfoBoxVisibility,
      goToContactUs
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../styles/_colors';

nav.kpt-configurator-navigation {
  min-height: 48px;
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: $blue-dark;
  color: $white;
  position: relative;

  .configurator-profile-item {
    width: 240px;
  }

  .configurator-brand {
    padding-left: 1rem;
    user-select: none;
  }
  
  .configurator-profile {
    display: flex;
    align-items: center;
    padding-right: 1rem;
  }
}
</style>
